export default "/images/vendor/@alquiler-argentina/aa-componentes/es/logo-right.svg?aec95295a8f7f57e058797d8939bc20f";